import * as React from 'react';
import { Segment, Container, Header, Grid, Button, Image } from 'semantic-ui-react';
import { ExpandableProblemSolutionItem } from './ExpandableProblemSolutionItem';

export const ProblemSegment = (props: any) =>
  <Segment style={{ padding: '0em', backgroundColor: "#F2F3F5", marginTop: 4 }} vertical>
    <Container>
      <Header
        as="h1"
        textAlign='center'
        style={{ paddingTop: "2em", paddingBottom: "1em" }}
      >
        The Problem: Status Quo
    </Header>

      <Grid container stackable verticalAlign='middle'>
        <Grid.Row>
          <Grid.Column width={8}>
            <p style={{ fontSize: '1.33em' }}>
              Most startups fail, there are many reasons for that, one of which being that the product runs out of money before it can find market fit.</p>
            <p style={{ fontSize: '1.33em' }}>
              Another reason startups fail is because most entrepreneurs and their founding team are not able to do everything a startup needs throughout its life cycle. Risk of financial ruin and loss of company vision dissuade many would be entrepreneurs from embarking on the path to creating products.</p>
          </Grid.Column>
          <Grid.Column floated='right' textAlign="center" width={6}>
            <Image
                size='large'
                src='/images/lonch-problem.png'
                style={{ display: "inline-block" }}
              />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns='equal' stackable style={{ marginTop: "4em", marginBottom: "2em" }}>
        <Grid.Row textAlign='center'>

          <ExpandableProblemSolutionItem
            icon='map outline'
            header="Accessibility"
            description={() => <p>Most startup infrastructure, like incubators and accelerators, are based in faraway places like big cities and Silicon Valley. </p>}
            more={() => <p>Accessing these resources usually requires relocation to already crowded and expensive places, just for a chance to be successful.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='dollar'
            header="Startup Capital"
            description={() => <p>Companies that need money to cover upfront expenses become burdened with debt, or must sell ownership of their vision.</p>}
            more={() => <p>No capital means nobody knows about your idea, you can’t hire domain experts to build your product from that idea, and you can’t ship your product.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='warning'
            header="Risk / Reward"
            description={() => <p>Business owners assume almost all the risk. Employees or contractors assume very little risk but gain stability.</p>}
            more={() => <p>Assuming the majority of the risk puts the onus on the company to innovate while mitigating as much risk as possible, stalling out many potential products</p>}
          />

          <ExpandableProblemSolutionItem
            icon='lock'
            header="Lock-in"
            description={() => <p>Neither companies nor employee can branch out and try new things outside of the established business roles.</p>}
            more={() => <p>Interests shift over time which results in churn and brain drain from employees, and uninspired offerings from companines</p>}
          />

        </Grid.Row>

      

      </Grid>

        <Container
          textAlign="center"
          style={{ paddingBottom: '4em' }}
        >
          <Button as="a" href="#solution-segement" size="huge">
            What's a better way?
          </Button>
        </Container>

    </Container>

  </Segment>


// WEBPACK FOOTER //
// ./src/home/ProblemSegment.tsx